'use strict';

const processInclude = require('base/util');

processInclude(require('./cart/cart'));
processInclude(require('./cart/minicart'));
processInclude(require('./cart/cartRecommendation'));
processInclude(require('./product/updateProductAction'));